{
  "user-profile": {
    "buttons": {
      "confirm-email": "Potvrzení e-mailu",
      "confirm-phone-nr": "Potvrzení telefonního čísla",
      "update": "Update",
      "update-password": "Aktualizace hesla",
      "update-phone-nr": "Aktualizace telefonního čísla"
    },
    "text": {
      "communication": "Komunikace",
      "communication-hint": "Většina salonů používá pro komunikaci e-mail (např. pro potvrzení schůzky), ale některé nabízejí také možnost využití SMS. Dáváte v těchto případech přednost přijímání SMS?",
      "confirm-email": "Potvrďte prosím svůj e-mail",
      "confirm-phone-nr": "Potvrďte prosím své telefonní číslo",
      "contact-data": "Kontaktní údaje",
      "in-second": "v {{seconds}} s",
      "password": "Heslo",
      "personal-data": "Osobní údaje",
      "pin-code": "PIN kód",
      "pin-code-hint": "Nastavte prosím všechny {{ numberOfPinDigit }} číslic PIN, které se mají aktualizovat. Tento PIN se používá pouze pro přihlášení do aplikací Beauty Checkin a Beauty Checkout.",
      "update-password-by-email": "Kód PIN vám bude zaslán e-mailem. Tento kód PIN budete potřebovat k potvrzení nového hesla.",
      "update-password-by-sms": "Kód PIN vám bude zaslán prostřednictvím SMS. Tento kód PIN budete potřebovat k potvrzení nového hesla.",
      "update-success": "Úspěšně aktualizováno!",
      "via-email": "Ne",
      "via-sms": "Ano"
    }
  }
}
